<template>
  <div 
    v-if="level == 0"
    class="sticky top-0 z-10 bg-blue-500 mb-1 rounded">
    <div class="grid-value items-end text-white">
      <span class="text-center">Переменная политики</span>
      <span class="text-center">Значение </span>
    </div>
  </div>
  <div v-if="model" :style="{
    paddingLeft: level > 0 ? '40px' : 0,
    borderLeft: level > 0 ? '1px solid red' : 0
  }">
    <template 
      v-for="(pv, index) in model"
      :key="pv.code">
        <Item v-model="model[index]"
          :event-schema="eventSchema"
          @select-value="(mm: IMarketingMaping) => emit('selectValue', mm)"
          @update-mapping="emit('updateMapping')"
          :parent="parent"
          :level="level"
        />
    </template>
  </div>
</template>

<style scoped lang="scss">
.grid-value {
  @apply grid grid-cols-[260px,260px,140px] gap-3
}
</style>

<script lang="ts" setup>
import type { IMarketingMaping } from '~/types/marketing/marketing-types';
import Item from './item.vue';

const model = defineModel<IMarketingMaping[]>({required: true})
const props = defineProps<{
  eventSchema: []
  parent?: any|undefined
  level: number
}>()  

const emit = defineEmits<{
  selectValue: [mm: IMarketingMaping]
  updateMapping: []
}>()

</script>